<template>
  <div>
    <div class="fixed-floating">
      <a href="/2024_schedule" target="_blank"
        ><img src="@/assets/img/newGlobal/main/popup/24_popup.png"
      /></a>
    </div>
    <ul class="quick-floating">
      <li>
        <a
          href="https://carrotenglish.kr/phone/register_payment_global"
          target="_blank"
          class="quick-payment"
          >결제서비스</a
        >
      </li>
      <!-- <li>
      <div class="quick-inquiry-btn">
        <img src="@/assets/img/newGlobal/main/quick/inquiry.png" alt="icon" />
        <p>문의하기</p>
      </div>
      <div class="quick-inquiry-list">
        <div>
          <img
            src="@/assets/img/newGlobal/main/quick/close.png"
            alt=""
            class="quick-close"
          />
          <ul>
            <li>
              <a
                href="https://carrotenglish.kr/phone/faq?carrotChat=open"
                target="_blank"
                >수업중 문의사항</a
              >
            </li>
            <li class="pointer" @click="clickInquiry">
              <a>기업교육 컨설팅문의</a>
            </li>
          </ul>
        </div>
      </div>
    </li> -->
    </ul>
  </div>
</template>
<script>
import { onMounted } from "vue";
export default {
  data() {
    return {};
  },
  methods: {
    clickInquiry() {
      document
        .getElementById("inqueryTxtArea")
        .scrollIntoView({ behavior: "smooth" });

      // const quickInquiryList = document.querySelector(".quick-inquiry-list");
      // quickInquiryList.style.display = "none";
    },
  },
  setup() {
    onMounted(() => {
      // quick
      // const quickInquiryBtn = document.querySelector(".quick-inquiry-btn");
      // const quickInquiryList = document.querySelector(".quick-inquiry-list");
      // const quickFloating = document.querySelector(".quick-floating");
      // quickInquiryBtn.addEventListener("click", function () {
      //   quickInquiryList.style.display = "block";
      //   quickFloating.style.zIndex = "2";
      // });
      // const quickClose = document.querySelector(".quick-close");
      // quickClose.addEventListener("click", function () {
      //   quickInquiryList.style.display = "none";
      //   quickFloating.style.zIndex = "1";
      // });
    });
  },
};
</script>
<style lang="scss" scoped>
a,
img {
  display: block;
}

article {
  display: block;
}

.container {
  width: calc(100% - 40px);
  max-width: 1200px;
  margin: 0 auto;
}
// 결제서비스, 문의하기
.quick-floating {
  position: absolute;
  bottom: 40px;
  right: 40px;
  width: 150px;

  li {
    position: relative;

    .quick-payment {
      font-size: 15px;
      color: #ffffff;
      text-align: center;
      padding: 10px 20px;
      background-color: #0ecedd;
      border-radius: 5px;
    }

    .quick-inquiry-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 5px;
      font-size: 15px;
      color: #ffffff;
      text-align: center;
      padding: 10px 20px;
      background-color: #0ecedd;
      border-radius: 5px;
      cursor: pointer;
    }

    .quick-inquiry-list {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.8);

      > div {
        position: absolute;
        bottom: 162px;
        right: 40px;
        width: 150px;
        display: flex;
        flex-direction: column;
        gap: 10px 0;

        > img {
          width: 30px;
          align-self: flex-end;
          cursor: pointer;
        }

        > ul {
          background-color: #ffffff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;

          li {
            a {
              font-size: 13px;
              color: #000000;
              text-align: center;
              padding: 10px 0;
            }
          }
        }
      }
    }

    a > img {
      width: 150px;
    }
  }
}

.fixed-floating {
  position: fixed;
  bottom: 102px;
  right: 40px;
  width: 150px;

  img {
    width: 100%;
  }
}
</style>
